// src/components/trending/TrendingTopicsChart.jsx

import React from 'react';
import '../../styles/trending/TrendingChart.css';

const TrendingTopicsChart = ({ topics }) => {
  // Sort topics by percentage in descending order
  const sortedTopics = [...topics].sort((a, b) => b.percentage - a.percentage);
  
  // Get top 5 topics
  const topTopics = sortedTopics.slice(0, 5);
  
  // Find the maximum percentage to calculate relative widths
  const maxPercentage = Math.max(...topTopics.map(topic => topic.percentage));
  
  return (
    <div className="trending-chart">
      {topTopics.map((topic, index) => (
        <div key={index} className="chart-row">
          <div className="chart-bar-container">
            <div 
              className="chart-bar" 
              style={{ 
                width: `${(topic.percentage / maxPercentage) * 100}%`,
                backgroundColor: getTopicColor(topic.title)
              }}
            >
              <span className="bar-label">{topic.title}</span>
            </div>
          </div>
          <div className="chart-percentage">
            <span>{topic.percentage}% </span>
            <span className={`trend-indicator ${topic.trend}`}>
              {topic.trend === 'up' ? '↑' : '↓'}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

// Helper function to assign colors based on topic categories
const getTopicColor = (topicName) => {
  const colors = {
    'Economy': '#08773c', // Australian green
    'Education': '#00843d',
    'Environment': '#006b3d',
    'Healthcare': '#008542',
    'Justice': '#f9cf00', // Australian gold
    'Social Services': '#f1b434',
    'Infrastructure': '#d5a021',
    'Foreign Affairs': '#ffcd00',
    // Default
    'default': '#08773c'
  };
  
  return colors[topicName] || colors.default;
};

export default TrendingTopicsChart;